import React, { useState } from "react";
import { Input, Button } from "reactstrap";
import FConstants from "../../../constants/FuncoesContants";
import "../../../assets/css/params.css";
import {
  MdArrowDropDown,
  MdArrowDropUp,
  MdArrowUpward,
  MdDelete,
  MdPlusOne,
} from "react-icons/md";

function Parametros({ params, onAddParam, onChageParam, type, onRemoveParam }) {
  const [expandedIndexes, setExpandedIndexes] = useState([]);

  const toggleExpand = (index) => {
    if (expandedIndexes.includes(index)) {
      setExpandedIndexes(expandedIndexes.filter((i) => i !== index));
    } else {
      setExpandedIndexes([...expandedIndexes, index]);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {params.map((e, index) => (
        <div className="params-section" key={index}>
          <div className="params-header" onClick={() => toggleExpand(index)}>
            <span>{e.label}:</span>
            <div color="link">
              {expandedIndexes.includes(index) ? (
                <MdArrowDropUp size={25} />
              ) : (
                <MdArrowDropDown size={25} />
              )}
            </div>
          </div>

          {expandedIndexes.includes(index) && (
            <div className="params-details">
              <div className="params-field">
                <label>Nome do Parâmetro:</label>
                <Input
                  onChange={({ target }) =>
                    onChageParam(e.id, "label", target.value)
                  }
                  value={e.label}
                />
                <label
                  className="mt-1"
                  style={{
                    fontSize: 9,
                    fontStyle: "italic",
                    color: "red",
                    fontWeight: "400",
                  }}
                >
                  É proibido que parâmetros de entrada e/ou saída na mesma
                  função possuam os mesmos nomes (duplicados).
                </label>
              </div>
              <div className="params-field">
                <label>Tipo do Parâmetro:</label>
                <Input
                  type="select"
                  onChange={({ target }) =>
                    onChageParam(e.id, "variable_type", target.value)
                  }
                  value={e.variable_type}
                >
                  <option disabled selected />
                  <option value="telefone">Telefone</option>
                  <option value="text">Texto</option>
                  <option value="arquivo">Arquivo</option>
                  <option value="array">Array de Itens</option>
                  <option value="dynamic-simples">Dinâmica Simples</option>
                  <option value="dynamic">Dinâmica Webhook</option>
                </Input>
              </div>

              {e?.type !== "output" ? (
                <div className="params-field">
                  <label>Tipo de Campo:</label>
                  <Input
                    type="select"
                    value={e.dataType}
                    onChange={({ target }) =>
                      onChageParam(e.id, "dataType", target.value)
                    }
                  >
                    <option disabled selected />
                    {FConstants.TIPOS_DE_CAMPOS_PARAMETROS.map((e) => (
                      <option value={e.value}>{e.label}</option>
                    ))}
                  </Input>
                </div>
              ) : null}

              <div>
                <Button
                  onClick={() => onRemoveParam(e.id)}
                  color="danger"
                  style={{ marginTop: 15, fontSize: 10 }}
                >
                  <MdDelete /> Remover Parâmerto
                </Button>
              </div>
            </div>
          )}
        </div>
      ))}

      <div className="params-section">
        <Button color="primary" onClick={() => onAddParam(type)}>
          + Novo Parâmetro
        </Button>
      </div>
    </div>
  );
}

export default Parametros;
